var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout-padding" },
    [
      _c(
        "q-tabs",
        {
          ref: "tabs",
          staticClass: "settings-tabs round-borders no-scroll",
          attrs: { color: "white", "underline-color": "primary" }
        },
        [
          _c("q-tab", {
            attrs: {
              slot: "title",
              name: "general",
              default: "",
              label: _vm.$t("general"),
              color: "black"
            },
            slot: "title"
          }),
          _c("q-tab", {
            attrs: {
              slot: "title",
              name: "security",
              label: _vm.$t("security"),
              color: "black"
            },
            slot: "title"
          }),
          _c("q-tab", {
            attrs: {
              slot: "title",
              name: "danger-zone",
              label: _vm.$t("danger_zone"),
              color: "black"
            },
            slot: "title"
          }),
          _c("general-settings", { on: { selectTab: _vm.selectTab } }),
          _c("security-settings"),
          _c("danger-zone-settings")
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }